import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFetchBaseQuery } from "../apiFetchBaseQuery";
import { AppSupportPayload, AppSupportSuccessResponse } from "@/types/AppSupport";

export interface AppStateSlice {
	support: {
		show: boolean;
		withAgencyId: number;
		showThanks: boolean;
	};
}

const initialState: AppStateSlice = {
	support: {
		show: false,
		withAgencyId: 0,
		showThanks: false,
	},
};

const appStateSlice = createSlice({
	name: "appSlice",
	initialState,
	reducers: {
		toggleSupportModal(state, action: PayloadAction<Omit<AppStateSlice["support"], "showThanks">>) {
			state.support.show = action.payload.show;
			state.support.withAgencyId = action.payload.withAgencyId;
			state.support.showThanks = false;
		},
		toggleThanks(state, action: PayloadAction<Pick<AppStateSlice["support"], "showThanks">>) {
			state.support.showThanks = action.payload.showThanks;
		},
	},
});

export const appStateApiSlice = createApi({
	reducerPath: "appStateApiSlice",
	baseQuery: apiFetchBaseQuery,
	tagTypes: ["support"],
	endpoints: builder => ({
		createSupportTicket: builder.mutation<AppSupportSuccessResponse, AppSupportPayload>({
			query: payload => ({
				url: "/support/contact",
				method: "POST",
				body: payload,
			}),
		}),
	}),
});

export const { toggleSupportModal, toggleThanks } = appStateSlice.actions;
export default appStateSlice.reducer;
export const { useCreateSupportTicketMutation } = appStateApiSlice;
